/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateExperienceCompanyRequestDto } from '../models';
// @ts-ignore
import type { ExperienceCompanyDto } from '../models';
// @ts-ignore
import type { ExperienceCompanyIdDto } from '../models';
// @ts-ignore
import type { GetExperienceCompaniesResponseDto } from '../models';
// @ts-ignore
import type { UpdateExperienceCompanyRequestDto } from '../models';
/**
 * ExperienceCompaniesRestApi - axios parameter creator
 */
export const ExperienceCompaniesRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new experience company
         * @param {CreateExperienceCompanyRequestDto} createExperienceCompanyRequestDto Experience company details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExperienceCompany: async (createExperienceCompanyRequestDto: CreateExperienceCompanyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createExperienceCompanyRequestDto' is not null or undefined
            assertParamExists('createExperienceCompany', 'createExperienceCompanyRequestDto', createExperienceCompanyRequestDto)
            const localVarPath = `/api/v1/experience-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExperienceCompanyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an experience company
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExperienceCompany: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('deleteExperienceCompany', 'companyId', companyId)
            const localVarPath = `/api/v1/experience-companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all experience companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperienceCompanies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/experience-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get experience company details
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperienceCompany: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getExperienceCompany', 'companyId', companyId)
            const localVarPath = `/api/v1/experience-companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an experience company
         * @param {number} companyId 
         * @param {UpdateExperienceCompanyRequestDto} updateExperienceCompanyRequestDto Experience company details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExperienceCompany: async (companyId: number, updateExperienceCompanyRequestDto: UpdateExperienceCompanyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateExperienceCompany', 'companyId', companyId)
            // verify required parameter 'updateExperienceCompanyRequestDto' is not null or undefined
            assertParamExists('updateExperienceCompany', 'updateExperienceCompanyRequestDto', updateExperienceCompanyRequestDto)
            const localVarPath = `/api/v1/experience-companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExperienceCompanyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperienceCompaniesRestApi - functional programming interface
 */
export const ExperienceCompaniesRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperienceCompaniesRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new experience company
         * @param {CreateExperienceCompanyRequestDto} createExperienceCompanyRequestDto Experience company details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExperienceCompany(createExperienceCompanyRequestDto: CreateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperienceCompanyIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExperienceCompany(createExperienceCompanyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperienceCompaniesRestApi.createExperienceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an experience company
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExperienceCompany(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExperienceCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperienceCompaniesRestApi.deleteExperienceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all experience companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExperienceCompanies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExperienceCompaniesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExperienceCompanies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperienceCompaniesRestApi.getExperienceCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get experience company details
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExperienceCompany(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperienceCompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExperienceCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperienceCompaniesRestApi.getExperienceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an experience company
         * @param {number} companyId 
         * @param {UpdateExperienceCompanyRequestDto} updateExperienceCompanyRequestDto Experience company details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExperienceCompany(companyId: number, updateExperienceCompanyRequestDto: UpdateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExperienceCompany(companyId, updateExperienceCompanyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperienceCompaniesRestApi.updateExperienceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExperienceCompaniesRestApi - factory interface
 */
export const ExperienceCompaniesRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperienceCompaniesRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new experience company
         * @param {CreateExperienceCompanyRequestDto} createExperienceCompanyRequestDto Experience company details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExperienceCompany(createExperienceCompanyRequestDto: CreateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExperienceCompanyIdDto> {
            return localVarFp.createExperienceCompany(createExperienceCompanyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an experience company
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExperienceCompany(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExperienceCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all experience companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperienceCompanies(options?: RawAxiosRequestConfig): AxiosPromise<GetExperienceCompaniesResponseDto> {
            return localVarFp.getExperienceCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get experience company details
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperienceCompany(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExperienceCompanyDto> {
            return localVarFp.getExperienceCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an experience company
         * @param {number} companyId 
         * @param {UpdateExperienceCompanyRequestDto} updateExperienceCompanyRequestDto Experience company details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExperienceCompany(companyId: number, updateExperienceCompanyRequestDto: UpdateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateExperienceCompany(companyId, updateExperienceCompanyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExperienceCompaniesRestApi - interface
 */
export interface ExperienceCompaniesRestApiInterface {
    /**
     * 
     * @summary Create a new experience company
     * @param {CreateExperienceCompanyRequestDto} createExperienceCompanyRequestDto Experience company details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createExperienceCompany(createExperienceCompanyRequestDto: CreateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExperienceCompanyIdDto>;

    /**
     * 
     * @summary Delete an experience company
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteExperienceCompany(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get all experience companies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperienceCompanies(options?: RawAxiosRequestConfig): AxiosPromise<GetExperienceCompaniesResponseDto>;

    /**
     * 
     * @summary Get experience company details
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperienceCompany(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExperienceCompanyDto>;

    /**
     * 
     * @summary Update an experience company
     * @param {number} companyId 
     * @param {UpdateExperienceCompanyRequestDto} updateExperienceCompanyRequestDto Experience company details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperienceCompany(companyId: number, updateExperienceCompanyRequestDto: UpdateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ExperienceCompaniesRestApi - object-oriented interface
 */
export class ExperienceCompaniesRestApi extends BaseAPI implements ExperienceCompaniesRestApiInterface {
    /**
     * 
     * @summary Create a new experience company
     * @param {CreateExperienceCompanyRequestDto} createExperienceCompanyRequestDto Experience company details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createExperienceCompany(createExperienceCompanyRequestDto: CreateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig) {
        return ExperienceCompaniesRestApiFp(this.configuration).createExperienceCompany(createExperienceCompanyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an experience company
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteExperienceCompany(companyId: number, options?: RawAxiosRequestConfig) {
        return ExperienceCompaniesRestApiFp(this.configuration).deleteExperienceCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all experience companies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExperienceCompanies(options?: RawAxiosRequestConfig) {
        return ExperienceCompaniesRestApiFp(this.configuration).getExperienceCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get experience company details
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExperienceCompany(companyId: number, options?: RawAxiosRequestConfig) {
        return ExperienceCompaniesRestApiFp(this.configuration).getExperienceCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an experience company
     * @param {number} companyId 
     * @param {UpdateExperienceCompanyRequestDto} updateExperienceCompanyRequestDto Experience company details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateExperienceCompany(companyId: number, updateExperienceCompanyRequestDto: UpdateExperienceCompanyRequestDto, options?: RawAxiosRequestConfig) {
        return ExperienceCompaniesRestApiFp(this.configuration).updateExperienceCompany(companyId, updateExperienceCompanyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

